import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

const initialState: any = '';

export const tokenDataVerifierSlice = createSlice({
  name: 'tokenDataVerifier',
  initialState,
  reducers: {
    tokenDataVerifier: (state, action: PayloadAction<any>) => {
      state = action.payload;
      return state;
    },
  },
});

export const { tokenDataVerifier } = tokenDataVerifierSlice.actions;

export default tokenDataVerifierSlice.reducer;
